import React from 'react';
/* import ReactDOM from 'react-dom'; */
import './registrarEmpleado.scss';
import AppActualizarRegistro from './AppActualizarRegistro';

function ActualizarDatosEmpleado() {
  return (
    <div>
      <AppActualizarRegistro />
    </div>
  );
}

export default ActualizarDatosEmpleado;
